import {
  EVENT_ADD_NEW,
  EVENT_ADD_NEW_SUCCESS,
  EVENT_ADD_NEW_ERROR,
  EVENT_DELETE,
  EVENT_DELETE_ERROR,
  EVENT_DELETE_SUCCESS,
  EVENT_EDIT,
  EVENT_EDIT_ERROR,
  EVENT_EDIT_SUCCESS,
  EVENT_GET_BY_ID,
  EVENT_GET_BY_ID_ERROR,
  EVENT_GET_BY_ID_SUCCESS,
  EVENT_GET_LIST,
  EVENT_GET_LIST_ERROR,
  EVENT_GET_LIST_SUCCESS,
  EVENT_ADD_NEW_REQUEST,
  EVENT_STATUS_CHANGE,
  EVENT_STATUS_CHANGE_SUCCESS,
  EVENT_STATUS_CHANGE_ERROR,
  EVENT_GET_LIST_BY_QUERY,
  EVENT_GET_LIST_BY_QUERY_SUCCESS,
  EVENT_GET_LIST_BY_QUERY_ERROR,
} from '../actions';
// events
const initialState = {
  events: [],
  event: null,
  loading: false,
  error: null,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case EVENT_GET_BY_ID:
      return {
        ...state,
        loading: true,
        error: null,
        editSuccess: false,
      };
    case EVENT_STATUS_CHANGE:
      return {
        ...state,
        loading: true,
        error: null,
        editSuccess: false,
      };
    case EVENT_STATUS_CHANGE_SUCCESS:
      return {
        ...state,
        events: state.events.map(c => {
          return c.id === payload.id ? payload : c;
        }),
        event: payload,
        error: null,
        loading: false,
      };
    case EVENT_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        event: payload,
      };

    case EVENT_ADD_NEW_REQUEST:
      return {
        ...state,
        addSuccess: false,
      };
    case EVENT_GET_LIST_BY_QUERY:
    case EVENT_GET_LIST:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case EVENT_GET_LIST_BY_QUERY_SUCCESS:
    case EVENT_GET_LIST_SUCCESS:
      return {
        ...state,
        events: payload,
        loading: false,
      };
    case EVENT_ADD_NEW:
      return {
        ...state,
        loading: true,
        error: null,
        addSuccess: false,
      };

    case EVENT_ADD_NEW_SUCCESS:
      return {
        ...state,
        loading: false,
        event: payload,
        events: state.events.concat(payload),
        addSuccess: true,
      };

    case EVENT_EDIT:
      return {
        ...state,
        loading: true,
        error: null,
        editSuccess: false,
      };
    case EVENT_EDIT_SUCCESS:
      return {
        ...state,
        events: state.events.map(c => {
          return c.id === payload.id ? payload : c;
        }),
        event: payload,
        error: null,
        loading: false,
        editSuccess: true,
      };
    case EVENT_DELETE:
      return {
        ...state,
        loading: true,
        error: null,
        deleteSuccess: false,
      };
    case EVENT_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        events: state.events.filter(c => c.id !== payload),
        deleteSuccess: true,
      };
    case EVENT_GET_LIST_BY_QUERY_ERROR:
    case EVENT_DELETE_ERROR:
    case EVENT_ADD_NEW_ERROR:
    case EVENT_EDIT_ERROR:
    case EVENT_GET_BY_ID_ERROR:
    case EVENT_GET_LIST_ERROR:
    case EVENT_STATUS_CHANGE_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
};
